import { CatVo } from "./dataObjects/CatVo";


/* eslint-disable @typescript-eslint/no-useless-constructor */
export class MainStorage
{
    private static instance:MainStorage | null=null;

    public subjectID:number=3;
    public subjects:CatVo[]=[];
    public userCode:string='';
    public isLoggedIn:boolean=false;
    public gems:number=0;
    public xp:number=0;
    public streak:number=0;
    public userLevel:number=0;
    public userName:string='';
    public isAdmin:boolean=false;
    public playedGames:number[]=[];
    public unlockedGames:number[]=[];
    constructor()
    {
        //
        (window as any).ms=this;
    }

    public static getInstance()
    {
        if (this.instance===null)
        {
            this.instance=new MainStorage();
        }
        return this.instance;
    }
    public checkPlayed(gameID:number)
    {
        return this.playedGames.indexOf(gameID)!==-1;
    }
    public checkUnlocked(gameID:number)
    {
        return this.unlockedGames.indexOf(gameID)!==-1;
    }
}